import styled from 'styled-components';
import { cssVars } from '../../shared/lib/styledTheme';

interface SidebarIconContainerProps {
  $expanded?: boolean;
  $active?: boolean;
}

interface SidebarIconIconProps {
  $expanded?: boolean;
  $active?: boolean;
}

interface SidebarIconLabelProps {
  $expanded?: boolean;
  $active?: boolean;
}

export const SidebarIconIcon = styled.span<SidebarIconIconProps>`
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${(props: SidebarIconIconProps) => props.$expanded ? '26px' : '24px'};
  height: ${(props: SidebarIconIconProps) => props.$expanded ? '26px' : '24px'};
  flex-shrink: 0;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  color: ${(props: SidebarIconIconProps) => props.$active ? '#0d6efd' : cssVars.textPrimary};
  transform: ${(props: SidebarIconIconProps) => props.$active ? 'scale(1.05)' : 'scale(1)'};

  svg {
    width: 100%;
    height: 100%;
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  }
`;

export const SidebarIconLabel = styled.span<SidebarIconLabelProps>`
  margin-left: ${(props: SidebarIconLabelProps) => props.$expanded ? '14px' : '0'};
  font-size: ${(props: SidebarIconLabelProps) => props.$expanded ? '14px' : '0'};
  font-weight: ${(props: SidebarIconLabelProps) => props.$active ? '600' : '500'};
  white-space: nowrap;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  color: ${(props: SidebarIconLabelProps) => props.$active ? '#0d6efd' : cssVars.textPrimary};
  letter-spacing: -0.01em;
  opacity: ${(props: SidebarIconLabelProps) => props.$expanded ? '1' : '0'};
  transform: ${(props: SidebarIconLabelProps) => props.$expanded ? 'translateX(0)' : 'translateX(-8px)'};
`;

export const SidebarIconContainer = styled.div<SidebarIconContainerProps>`
  display: flex;
  align-items: center;
  width: 100%;
  padding: ${(props: SidebarIconContainerProps) => props.$expanded ? '10px 16px' : '10px 0'};
  cursor: pointer;
  border-radius: ${(props: SidebarIconContainerProps) => props.$expanded ? '12px' : '10px'};
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  color: ${cssVars.textPrimary};
  margin: 0;
  justify-content: ${(props: SidebarIconContainerProps) => props.$expanded ? 'flex-start' : 'center'};
  position: relative;
  background: transparent;

  &:hover {
    ${SidebarIconIcon} {
      transform: scale(1.08);
      color: #0d6efd;
    }

    ${SidebarIconLabel} {
      color: #0d6efd;
      font-weight: 600;
    }
  }

  &:active {
    ${SidebarIconIcon} {
      transform: scale(1.05);
    }
  }
`;
